import { ToggleButton } from '@progress/kendo-react-dateinputs';
import { AirplaneOutline, AirportTowerOutline } from '../../../../../icons/icons';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setSetting } from '../../../../state/slices/settings-slice';

export function MonitorStatusToolbarItem() {
    const visible = useAppSelector((x) => x.settings.toolbarShowMonitor);
    const showAirportMonitorStatus = useAppSelector((x) => x.settings.showAirportMonitorStatus);
    const showAircraftMonitorStatus = useAppSelector((x) => x.settings.showAircraftMonitorStatus);
    const dispatch = useAppDispatch();

    if (!visible) {
        return <></>;
    }

    return (
        <div className="telerik-button-group" id="monitor-status-tools">
            <ToggleButton
                togglable={true}
                selected={showAirportMonitorStatus}
                id="airport-monitor-status-btn"
                data-tooltip-bottom
                svgIcon={AirportTowerOutline}
                title="Airport Monitor Status icons"
                onClick={() => dispatch(setSetting('showAirportMonitorStatus', !showAirportMonitorStatus))}
            />

            <ToggleButton
                togglable={true}
                selected={showAircraftMonitorStatus}
                data-tooltip-bottom
                id="aircraft-monitor-status-btn"
                svgIcon={AirplaneOutline}
                title="Fleet Monitor Status icons"
                onClick={() => dispatch(setSetting('showAircraftMonitorStatus', !showAircraftMonitorStatus))}
            />
        </div>
    );
}
